import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.css' // Import custom styles
import request from '@/utils/request'
import { formattedTextBr } from "@/utils/index";
import { download } from "@/utils/request";
import './router/permission' // 引入路由守卫
//图片上传组件
import UploadImage from './components/UploadImage.vue'

Vue.use(ElementUI)
// 下载文件
Vue.prototype.download = download
Vue.prototype.formattedTextBr = formattedTextBr

Vue.component('UploadImage', UploadImage)
// 基准大小
const baseSize = 16
// 设置固定 rem 大小（禁用动态缩放）
function setRem() {
  document.documentElement.style.fontSize = baseSize + 'px'
}
// 初始化
setRem()
// 移除 window.onresize 的动态缩放监听，或者保持 setRem 逻辑但内容固定
window.onresize = function () {
  setRem()
}

// 将 axios 实例挂载到 Vue 原型上
Vue.prototype.$http = request

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
